import { Translate } from "@phosphor-icons/react";

import FilterButton from "common/components/ui/FilterButton";
import {
  Select,
  SelectContent,
  SelectItem,
  SelectItemText,
  SelectTrigger,
} from "common/components/ui/Select";
import LANGUAGES from "common/constants/languages";

import { useCampaignFlowContext } from "../../../../context/CampaignFlowContext";
import useFlowActions from "../../../../hooks/useFlowActions";
import { getLanguageName } from "../../../../utils";

import type { FlowTemplate } from "../../../../types";

export default function LanguageDropdown({
  flowTemplate,
}: {
  flowTemplate: FlowTemplate;
}) {
  const { flow, canEditFlow } = useCampaignFlowContext();
  const { setFlowLanguage } = useFlowActions(flow);

  const {
    source_language: languageCode,
    is_manual_language: isManualLanguage,
  } = flow;

  const isDisabled = !flowTemplate || !flowTemplate.original_id || !canEditFlow;

  return (
    <Select
      value={languageCode}
      onValueChange={(code) => setFlowLanguage(code, true)}
      disabled={isDisabled}
    >
      <SelectTrigger asChild>
        <FilterButton size="sm" leftIcon={<Translate weight="fill" />}>
          {languageCode && !isManualLanguage && (
            <span className="text-black-400">Detected: </span>
          )}
          {languageCode ? getLanguageName(languageCode) : "Language"}
        </FilterButton>
      </SelectTrigger>
      <SelectContent>
        {LANGUAGES.map(({ code, name }) => (
          <SelectItem value={code} key={code}>
            <SelectItemText>{name}</SelectItemText>
          </SelectItem>
        ))}
      </SelectContent>
    </Select>
  );
}
